(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3999],{

/***/ 57539:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'spinner';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f110';
var svgPathData = ['M437 142.9C418.3 161.6 387.9 161.6 369.1 142.9C350.4 124.1 350.4 93.73 369.1 74.98C387.9 56.24 418.3 56.24 437 74.98C455.8 93.73 455.8 124.1 437 142.9V142.9zM512 256C512 282.5 490.5 304 464 304C437.5 304 416 282.5 416 256C416 229.5 437.5 208 464 208C490.5 208 512 229.5 512 256zM304 464C304 490.5 282.5 512 256 512C229.5 512 208 490.5 208 464C208 437.5 229.5 416 256 416C282.5 416 304 437.5 304 464zM74.98 437C56.24 418.3 56.24 387.9 74.98 369.1C93.73 350.4 124.1 350.4 142.9 369.1C161.6 387.9 161.6 418.3 142.9 437C124.1 455.8 93.73 455.8 74.98 437V437zM437 437C418.3 455.8 387.9 455.8 369.1 437C350.4 418.3 350.4 387.9 369.1 369.1C387.9 350.4 418.3 350.4 437 369.1C455.8 387.9 455.8 418.3 437 437V437z', 'M304 48C304 74.51 282.5 96 256 96C229.5 96 208 74.51 208 48C208 21.49 229.5 0 256 0C282.5 0 304 21.49 304 48zM96 256C96 282.5 74.51 304 48 304C21.49 304 0 282.5 0 256C0 229.5 21.49 208 48 208C74.51 208 96 229.5 96 256zM74.98 74.98C93.73 56.23 124.1 56.23 142.9 74.98C161.6 93.73 161.6 124.1 142.9 142.9C124.1 161.6 93.73 161.6 74.98 142.9C56.24 124.1 56.24 93.73 74.98 74.98V74.98z'];

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.LM = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 75701:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[type]",
      function () {
        return __webpack_require__(92894);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);

var page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageId: -1,
    isMobile: 0,
    isTablet: 0,
    isDesktop: 0,
    isPublicDomain: 0,
    appSettings: [],
    destinationId: null,
    propertiesParams: {
        page_id: null,
        limit: 24,
        offset: 0,
        destinations: [],
        tags: [],
        themes: [],
        locations: [],
        statuses: 3
    }
});


/***/ }),

/***/ 56951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11101);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83974);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31969);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23158);








function BuilderHead(props) {
    var isRateParityWebAppPage = props.hasOwnProperty("isRateParityWebAppPage") ? props.isRateParityWebAppPage : false;
    var manifestPath = "/manifest.json";
    if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].booleanState */ .Z.booleanState(props.property)) {
        manifestPath = "../../" + manifestPath.split("/")[1];
    }
    var showRateParityWidget = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_general_show_rateparity_widget") == 1 ? true : false;
    });
    var seoRobotsInstructions = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_search_engine_instuctions");
    });
    var showCookieYes = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_enable") == 1 ? true : false;
    });
    var cookiesYesIdentifier = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_identifier");
    });
    var cookiesYesScript = function() {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(cookiesYesIdentifier)) {
            return "https://cdn-cookieyes.com/client_data/" + cookiesYesIdentifier + "/script.js";
        }
        return null;
    };
    var rateParityHasLoaded = function() {
        if (true) {
            return document.getElementById("rp-allinone");
        }
        return true;
    };
    var cookieYesHasLoaded = function() {
        if (true) {
            return document.getElementsByClassName("cky-preference-center").length > 0;
        }
        return true;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.font != null) {
            var head = document.getElementsByTagName("head")[0];
            var style = document.createElement("style");
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            switch(props.font){
                case "Roboto Slab":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Serif":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Roboto":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', sans-serif !important}";
                    break;
                case "Vollkorn":
                    link.href = "https://fonts.googleapis.com/css?family=Vollkorn:400,600,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Vollkorn', serif !important}";
                    break;
                case "Noto Sans":
                    link.href = "https://fonts.googleapis.com/css?family=Noto+Sans:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Noto Sans', sans-serif !important}";
                    break;
                case "Cousine":
                    link.href = "https://fonts.googleapis.com/css?family=Cousine:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', monospace !important}";
                    break;
                case "Playfair":
                    link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Playfair Display', serif !important}";
                    break;
                default:
                    link.href = "https://fonts.googleapis.com/icon?family=Material+Icons&display=swap";
                    break;
            }
            head.appendChild(link);
            head.appendChild(style);
        }
    });
    var googleSchema = {
        "@context": "https://schema.org/",
        "@type": "Organization",
        "name": "".concat(props.googleSchemaTitle),
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "".concat(props.googleSchemaStreetAddress),
            "addressLocality": "".concat(props.googleSchemaCity),
            "addressRegion": "".concat(props.googleSchemaCountry),
            "postalCode": "".concat(props.googleSchemaZip)
        },
        "telephone": "".concat(props.googleSchemaPhone)
    };
    var absoluteUrl = function(url) {
        if (!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(url)) return null;
        if (/^https?:\/\//i.test(url)) return url;
        var isLocal = /(^|\.)(localhost|local)(:\d+)?(\/|$)/i.test(url);
        return (isLocal ? "http://" : "https://") + url.replace(/^\/+/, "");
    };
    var canonicalUrl = absoluteUrl(props.seoUrl);
    var pageUrl = canonicalUrl || props.domain;
    var pageSchema = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(props.image_fb_meta) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        "@context": "https://schema.org/",
        "@type": "WebPage",
        "name": props.title
    }, pageUrl ? {
        "url": pageUrl
    } : {}), {
        "primaryImageOfPage": {
            "@type": "ImageObject",
            "url": props.image_fb_meta
        },
        "image": props.image_fb_meta
    }) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }),
            props.keywords != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: props.titleOfficial
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(seoRobotsInstructions) ? seoRobotsInstructions : "index, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: props.designColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "referrer",
                content: "strict-origin"
            }),
            canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            props.icon_60 != null && props.icon_60 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    })
                ]
            }),
            props.icon_76 != null && props.icon_76 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "76x76",
                href: props.icon_76
            }),
            props.icon_120 != null && props.icon_120 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "120x120",
                href: props.icon_120
            }),
            props.icon_152 != null && props.icon_152 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: props.icon_152
            }),
            props.icon_256 != null && props.icon_256 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "shortcut icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    })
                ]
            }),
            props.icon != null && props.icon != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: props.icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-touch-fullscreen",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:type",
                content: "place"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(props.desc_fb_meta) ? props.desc_fb_meta : props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.image_fb_meta
            }),
            props.image_fb_meta_width != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: String(props.image_fb_meta_width)
            }),
            props.image_fb_meta_height != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: String(props.image_fb_meta_height)
            }),
            props.lat_fb_meta != null && props.lat_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:latitude",
                content: props.lat_fb_meta
            }) : null,
            props.lon_fb_meta != null && props.lon_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:longitude",
                content: props.lon_fb_meta
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: props.site_name_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image:alt",
                content: props.twitter_img_alt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(googleSchema)
                }
            }),
            pageSchema && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(pageSchema)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: manifestPath
            }),
            !cookieYesHasLoaded() && showCookieYes && cookiesYesScript != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                id: "cookieyes",
                type: "text/javascript",
                src: cookiesYesScript(),
                defer: true
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            !rateParityHasLoaded() && !isRateParityWebAppPage && showRateParityWidget ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "text/javascript",
                    src: "https://code.rateparity.com/versions/installer.min.js",
                    defer: true
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BuilderHead);


/***/ }),

/***/ 29251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);


var ContentWrapper = function(param) {
    var ContentRender = param.ContentRender;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: ContentRender
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentWrapper);


/***/ }),

/***/ 32549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94549);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(382);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34357);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91932);





var RightModal = function(param) {
    var modalName = param.modalName, className = param.className, modalSize = param.modalSize, closeModal = param.closeModal, show = param.show, Title = param.Title, BodyRender = param.BodyRender, loaderStatus = param.loaderStatus, _disableClose = param.disableClose, disableClose = _disableClose === void 0 ? false : _disableClose;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(show || false), showSimpleModal = ref[0], setShowSimpleModal = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var hasHash = router.asPath.includes("#");
    var openHandler = function() {
        if (!hasHash) {
            router.push({
                hash: modalName + ""
            }, undefined, {
                scroll: false
            });
        }
        setShowSimpleModal(true);
    };
    var closeHandler = function() {
        if (disableClose) {
            return;
        }
        closeModal();
        setShowSimpleModal(false);
    };
    var clickOutSideHandler = function() {
        closeModal();
        setShowSimpleModal(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (show) openHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        show
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!hasHash && showSimpleModal) clickOutSideHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasHash
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        id: modalName,
        className: className,
        size: modalSize,
        show: showSimpleModal,
        onHide: closeHandler,
        animation: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Header */ .Z.Header, {
                children: [
                    disableClose ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        onClick: closeHandler
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-left m-t-0 m-b-0 d-block w-100",
                        children: Title
                    })
                ]
            }, 10001),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-body",
                children: !loaderStatus ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container p-l-0 p-r-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: BodyRender
                        })
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container p-t-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                height: 340,
                                className: "col-12 b-rad-lg d-block"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                height: 27,
                                className: "col-12 b-rad-lg d-block"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                height: 27,
                                className: "col-12 b-rad-lg d-block"
                            })
                        ]
                    })
                })
            })
        ]
    }, 1000);
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(RightModal));


/***/ }),

/***/ 92894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Index": function() { return /* binding */ Index; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _type_; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(95925);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/fontawesome-svg-core/index.mjs
var fontawesome_svg_core = __webpack_require__(95623);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/AppContext.tsx
var AppContext = __webpack_require__(1860);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/fontawesome-svg-core/styles.css
var styles = __webpack_require__(54197);
// EXTERNAL MODULE: ../../shared/node_modules/@fancyapps/ui/dist/fancybox.esm.js
var fancybox_esm = __webpack_require__(46797);
// EXTERNAL MODULE: ./components/head/BuilderHead.tsx
var BuilderHead = __webpack_require__(56951);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(46093);
// EXTERNAL MODULE: ./layouts/MainLayout.tsx + 6 modules
var MainLayout = __webpack_require__(66638);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./components/templates/properties/partials/RightModal.tsx
var RightModal = __webpack_require__(32549);
// EXTERNAL MODULE: ./components/templates/properties/partials/ContentWrapper.tsx
var ContentWrapper = __webpack_require__(29251);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-duotone-svg-icons/faSpinner.js
var faSpinner = __webpack_require__(57539);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(72976);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(8019);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/lab/Alert/Alert.js + 7 modules
var Alert = __webpack_require__(62415);
// EXTERNAL MODULE: ../../shared/node_modules/next/link.js
var next_link = __webpack_require__(75547);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/passwordProtection/PasswordProtection.tsx

















var PasswordProtection = function(props) {
    var t = (0,i18n/* useT */.NT)();
    var pageId = props.pageId;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)("clode"), modalState = ref[0], setModalState = ref[1];
    var ref1 = (0,react.useState)(false), formSubmitting = ref1[0], setFormSubmitting = ref1[1];
    var ref2 = (0,react.useState)(false), showResponseMessage = ref2[0], setShowResponseMessage = ref2[1];
    var ref3 = (0,react.useState)(null), formSuccess = ref3[0], setFormSuccess = ref3[1];
    var PASSWORD_CONFIRMED_KEY = "properties_password_confirmed_".concat(pageId);
    var propertiesLockEnabled = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_lock"));
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var data, formObject, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        setFormSubmitting(true);
                        data = new FormData(event.currentTarget);
                        formObject = Object.fromEntries(data.entries());
                        return [
                            4,
                            (0,client/* validatePropertiesPassword */.YB)({
                                "page_id": pageId
                            }, formObject)
                        ];
                    case 1:
                        response = _state.sent();
                        setShowResponseMessage(true);
                        if (response.success == 1) {
                            setFormSuccess(true);
                            sessionStorage.setItem(PASSWORD_CONFIRMED_KEY, "1");
                            dispatch((0,actions/* setPropertiesListPasswordConfirmed */._3)(true));
                        } else {
                            setFormSuccess(false);
                        }
                        setFormSubmitting(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (propertiesLockEnabled) {
            setModalState("password_modal");
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightModal/* default */.Z, {
            modalName: "password_modal",
            className: "stick-up",
            disableClose: true,
            Title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_solid_svg_icons/* faLock */.byT,
                        size: "xs"
                    }),
                    " ",
                    t("auth.areaProtected")
                ]
            }),
            modalSize: "sm",
            loaderStatus: false,
            closeModal: function() {
            // handleHide()
            },
            show: modalState === "password_modal",
            BodyRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                ContentRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row m-t-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 col-md-12 p-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-arial hint-text small pull-left letter-sp-normal fs-12 w-auto m-t-5 px-0",
                                            children: t("auth.enterPassword")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-group form-group-default bg-white b-transparent-master required",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "first_name",
                                                    className: "bold text-uppercase letter-sp-normal fs-12",
                                                    children: t("auth.password")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    id: "password",
                                                    name: "password",
                                                    type: "password",
                                                    className: "form-control",
                                                    required: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 col-md-12 p-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            id: "contact_submit",
                                            className: "btn btn-design-color text-uppercase letter-sp-normal fw-normal w-100",
                                            disabled: false,
                                            style: {
                                                padding: "6px 17px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("common.submit"),
                                                    formSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: faSpinner/* faSpinner */.LM,
                                                        spin: true,
                                                        className: "m-l-5 square-icon"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_solid_svg_icons/* faAngleRight */.yOZ,
                                                        className: "m-l-5 square-icon"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            className: "letter-sp-normal fw-normal w-100",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "w-100 text-center block pt-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_solid_svg_icons/* faAngleLeft */.EyR,
                                                        className: "m-r-5 square-icon"
                                                    }),
                                                    t("auth.backHome")
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 col-md-12 p-0 m-t-20",
                                    children: showResponseMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: formSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                            severity: "success",
                                            sx: {
                                                mb: "20px"
                                            },
                                            children: t("auth.loginSuccess")
                                        }) : formSuccess != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                            severity: "error",
                                            sx: {
                                                mb: "20px"
                                            },
                                            children: t("auth.wrongPassword")
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                })
                            ]
                        })
                    })
                })
            })
        }, 100)
    });
};
/* harmony default export */ var passwordProtection_PasswordProtection = (PasswordProtection);

;// CONCATENATED MODULE: ./pages/properties/[type]/index.tsx










fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;







var Header = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 60314));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60314)
            ];
        }
    },
    suspense: true
});
var Properties = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2817), __webpack_require__.e(5175), __webpack_require__.e(1370), __webpack_require__.e(4795), __webpack_require__.e(6171), __webpack_require__.e(5885), __webpack_require__.e(8859), __webpack_require__.e(2366)]).then(__webpack_require__.bind(__webpack_require__, 18859));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18859)
            ];
        }
    },
    suspense: true
});
var BottomSections = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 54180));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54180)
            ];
        }
    },
    suspense: true
});
var Scripts = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
var __N_SSP = true;
var Index = function(props) {
    var t = (0,i18n/* useT */.NT)();
    var pageContext = (0,react.useContext)(AppContext/* page */.M);
    pageContext.pageId = props.app_data.page_id;
    pageContext.isMobile = props.isMobile;
    pageContext.isTablet = props.isTablet;
    pageContext.isDesktop = props.isDesktop;
    pageContext.appSettings = props.app;
    var propertiesListPasswordConfirmed = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["propertiesListPasswordConfirmed"];
    });
    // useEffect(() => {
    //   console.log("debug propertiesListPasswordConfirmed", propertiesListPasswordConfirmed)
    // //   console.log("debug propertiesListPasswordConfirmed session", sessionStorage.getItem(`properties_password_confirmed_${pageId}`))
    // }, [propertiesListPasswordConfirmed]);
    var propertiesLockEnabled = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_lock"));
    });
    var ref = (0,react.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    var pageId = props.app_data.page_id;
    var dispatch = (0,es/* useDispatch */.I0)();
    react.useEffect(function() {
        fancybox_esm/* Fancybox.bind */.KR.bind("[data-fancybox]", {
            Image: {
                zoom: false
            }
        });
        if (window !== undefined) {
            setUrlHref(window.location.href + "/");
        }
    }, [
        urlHref
    ]);
    var domain = props.domain;
    var app = props.app;
    var builder = props.builder;
    var head = props.head;
    var footer = props.footer;
    var app_data = props.app_data;
    var navigation = props.navigation;
    var properties = props.properties;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var isDesktop = props.isDesktop;
    var metaTitle = app.builder.builder_property_seo_meta_title_cat;
    var metaKeys = app.builder.builder_property_seo_keywords;
    var meta_keys = metaKeys.split("__TAG__").map(function(item) {
        return item.trim();
    }).filter(Boolean);
    var titlePrefix = metaTitle !== "" && metaTitle != null ? metaTitle : t("common.villasCollection");
    var title = titlePrefix + " | " + head.data.title;
    var meta_desc = head.data.motto;
    var image_fb_meta = Checkers/* default.isValidArray */.Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    var contactIcons = {
        phoneIcon: app.showPhoneIconOnMenu,
        chatIcon: app.showChatIconOnMenu,
        mailIcon: app.showMailIconOnMenu,
        phoneIconData: app.menuPhoneIconData,
        chatIconData: app.menuChatIconData,
        mailIconData: app.menuMailIconData
    };
    // const containerClass = Checkers.googleMapsPropertyInit( app.googleMapsApiKey, app.viewMap, 0, 0 ) ? 'container-fluid px-2 px-md-3' : 'container';
    var containerClass = "container";
    (0,react.useEffect)(function() {
        if (!pageId) return;
        var confirmed = sessionStorage.getItem("properties_password_confirmed_".concat(pageId));
        // console.log("debug confirmed", confirmed, Checkers.valueToBoolean(confirmed))
        if (confirmed === "1") {
            dispatch((0,actions/* setPropertiesListPasswordConfirmed */._3)(true));
        }
    }, [
        pageId,
        propertiesLockEnabled
    ]);
    var ref1 = (0,react.useState)(false), sessionConfirmed = ref1[0], setSessionConfirmed = ref1[1];
    (0,react.useEffect)(function() {
        if (!pageId) return;
        var key = "properties_password_confirmed_".concat(pageId);
        var confirmed = sessionStorage.getItem(key);
        setSessionConfirmed(confirmed === "1");
    }, [
        pageId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderHead/* default */.Z, {
                title: title,
                titleOfficial: head.data.titleOfficial,
                domain: urlHref,
                icon_60: head.data.icon_60,
                icon_76: head.data.icon_76,
                icon_120: head.data.icon_120,
                icon_152: head.data.icon_152,
                icon_256: head.data.icon_256,
                icon: head.data.icon,
                title_fb_meta: title,
                desc_fb_meta: meta_desc,
                keywords: meta_keys,
                image_fb_meta: image_fb_meta,
                site_name_fb_meta: head.data.title,
                lat_fb_meta: head.location.latitude,
                lon_fb_meta: head.location.longitude,
                twitter_img_alt: title + meta_desc,
                googleSchemaContext: domain,
                googleSchemaTitle: head.data.title,
                googleSchemaStreetAddress: head.location[0].address,
                googleSchemaCity: head.location[0].city,
                googleSchemaCountry: head.location[0].country,
                googleSchemaZip: head.location[0].zip,
                googleSchemaPhone: head.location[0].phone,
                designColor: app.designColor,
                font: app.font,
                manager: false,
                property: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                children: !propertiesLockEnabled || propertiesListPasswordConfirmed || sessionConfirmed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Properties, {
                    app: app,
                    builder: builder,
                    propertiesIndex: true,
                    propertiesParams: props.propertiesParams,
                    properties_count: props.properties_count,
                    designMode: app.designMode,
                    searchbarRadius: app.searchbarRadius,
                    searchbarShadow: app.searchbarShadow,
                    bookingSearchbarWithBedrooms: app.bookingSearchbarWithBedrooms,
                    googleMapShow: app.viewMap,
                    googleMapApiKey: app.googleMapsApiKey,
                    propertiesFilters: props.propertiesFilters
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(passwordProtection_PasswordProtection, {
                        pageId: pageId
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Scripts, {})
        ]
    }));
};
/* harmony default export */ var _type_ = (Index);
function delay(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5693,4285,8340,8201,9007,5553,8412,289,9440,8805,6638,9774,2888,179], function() { return __webpack_exec__(75701); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);